<template>
  <div>
    <el-form size="mini"
             :inline="true"
             label-width="90">
      <el-form-item label="姓名">
        <el-input v-model="fname" clearable placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" @click="ue_GetUser" type="success">查询</el-button>
        <el-button icon="el-icon-plus" @click="ue_addUser" type="primary">增加</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="userData" :height="tb_height" stripe border size="mini">
      <el-table-column prop="id" label="编码" width="60"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" :disabled="scope.row.loginID==='admin'" @click="ue_EditUser(scope.row)"
                     size="mini" type="text" title="编辑">编辑
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="loginID" label="登录编号" width="120"></el-table-column>
      <el-table-column prop="name" label="姓名" width="150"></el-table-column>
      <el-table-column prop="companyid" :formatter="f_formatUser" show-overflow-tooltip label="所属公司"
                       width="200"></el-table-column>
      <el-table-column prop="power" :formatter="f_formatUser" label="权限" show-overflow-tooltip></el-table-column>
    </el-table>

    <el-dialog title="操作员信息维护"
               class="d-dialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="showEdit"
               width="550px">

      <el-form label-width="80px"
               size="mini"
               ref="userEdit"
               :rules="rules"
               :model="userEdit">
        <el-form-item label="编号">
          <el-input v-model="userEdit.id" :disabled="true" placeholder="自动生成"></el-input>
        </el-form-item>
        <el-form-item label="登录编号" prop="loginID">
          <el-input v-model="userEdit.loginID" placeholder="请输入登录编号，不能重复"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userEdit.name" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyid">
          <el-select v-model="userEdit.companyid" clearable placeholder="请选择公司信息">
            <el-option v-for="item in companyData" :value="item.id" :label="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限">
          <el-select v-model="userEdit.power" clearable style="width: 100%" placeholder="请选择权限信息，默认全部" multiple>
            <el-option-group v-for="group in pwoData"
                             :key="group.name"
                             :label="group.name">
              <el-option v-for="item in group.options" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="showEdit = false">关闭</el-button>
        <el-button size="mini" type="primary" @click.native="ue_saveUser">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import Utils from '../api/Utils'
  import * as Api from '../api/api'

  export default {
    data() {
      return {
        fname: "",
        user: JSON.parse(sessionStorage.getItem("user")),
        userData: [],
        showEdit: false,
        userEdit: {},
        tb_height:'400px',
        rules: {
          companyid: [
            {required: true, message: '请选择公司信息', trigger: 'blur'}
          ],
          loginID: [
            {required: true, message: '登录编号不能为空', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '姓名不能为空', trigger: 'blur'}
          ]
        },
        companyData: [],
        pwoData: Utils.powerOptions
      }
    },
    mounted() {
      this.f_GetCompany();

    },
    methods: {
      ue_addUser() {
        this.showEdit = true;
        this.userEdit = {};
        this.userEdit = {
          name: "",
          power: "",
          pwd: "123456",
          companyid: "",
          loginID: ""
        };
      },
      ue_EditUser(row) {
        this.showEdit = true;
        let xrow = JSON.parse(JSON.stringify(row));
        let power = xrow.power;
        xrow.power = power.split(",");
        this.userEdit = xrow;
      },
      ue_saveUser() {
        this.$refs.userEdit.validate((valid) => {
          if (valid) {
            let parms = JSON.parse(JSON.stringify(this.userEdit));
            let power = parms.power;
            if (!power || power.length === 0)
              parms.power = "";
            else
              parms.power = power.toString();

            Api.AddUser(parms).then(res => {
              if (res.code === 1) {
                this.showEdit = false;
                this.$message.success("保存成功");
                this.f_GetUser();
              } else {
                this.$alert(`保存失败${res.error}`, "提示信息");
              }
            })
          }
        });
      },

      ue_GetUser() {
        this.f_GetUser();
      },
      f_GetUser() {
        Api.GetUser({name: this.fname}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.userData = res.data;
          this.f_AutoHeight();
        });
      },
      f_GetCompany() {
        Api.GetCompany({}).then(res => {
          if (res.code === 1)
            this.companyData = res.data;
          this.f_GetUser();
        })
      },
      f_formatUser(row, column, cellvalue) {
        let col = column.property;
        let result = cellvalue;
        if (col === "companyid") {
          let dd = this.companyData.find(it => it.id == cellvalue);
          if (dd) result = dd.name;
        }
        if (col === "power") {
          if (cellvalue === "") result = "全部";
          else {
            let power = cellvalue.split(",");
            result = "";
            power.forEach((po) => {
              this.pwoData.forEach((o) => {
                o.options.forEach((oo) => {
                  if (po === oo.id) result += `,${oo.name}`;
                });
              });
            });
            result = result.substring(1);
          }
          let dd = this.companyData.find(it => it.id == cellvalue);
          if (dd) result = dd.name;
        }
        return result;
      },
      f_AutoHeight () {
        //初始化界面计算明细表格高度
        let gd = document.getElementsByClassName('el-table')[0];
        let bb = document.getElementsByClassName('icp-footer')[0];
        let gh = Utils.GetElHeight(gd, bb);
        this.tb_height = '' + parseInt(gh)+'px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/User.vue